import React from 'react';
import { withStyles } from "tss-react/mui";
import { FormControl } from '@mui/material';
import styles from './styles';

function FormElement(props) {
    const { classes, ...other } = props;
    return (
        <FormControl variant="standard" className={classes.formElement} {...other}>
            {props.children}
        </FormControl>
    );
}

export default withStyles(FormElement, styles);